function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { forwardRef } from "react";
import { Body, Checkbox, ErrorMessage, FieldLabel, Input, Textarea } from "../../atoms";
function RawFormField(_param, ref) {
    var id = _param.id, label = _param.label, name = _param.name, error = _param.error, className = _param.className, props = _objectWithoutProperties(_param, [
        "id",
        "label",
        "name",
        "error",
        "className"
    ]);
    if (props.type === "checkbox") {
        return /*#__PURE__*/ React.createElement("fieldset", {
            className: className
        }, props.type === "checkbox" && /*#__PURE__*/ React.createElement("div", {
            className: "grid gap-3 items-center grid-cols-[auto_1fr]"
        }, /*#__PURE__*/ React.createElement(Checkbox, _extends({
            id: id,
            ref: ref,
            name: name
        }, props.fieldProps)), /*#__PURE__*/ React.createElement("label", {
            htmlFor: id
        }, /*#__PURE__*/ React.createElement(Body, null, label))), !!error && /*#__PURE__*/ React.createElement(ErrorMessage, {
            className: "mt-3"
        }, error));
    }
    return /*#__PURE__*/ React.createElement("fieldset", {
        className: className
    }, /*#__PURE__*/ React.createElement(FieldLabel, {
        htmlFor: id
    }, label), props.type === "input" && /*#__PURE__*/ React.createElement(Input, _extends({
        id: id,
        ref: ref,
        name: name
    }, props.fieldProps)), props.type === "textarea" && /*#__PURE__*/ React.createElement(Textarea, _extends({
        id: id,
        ref: ref,
        name: name
    }, props.fieldProps)), !!error && /*#__PURE__*/ React.createElement(ErrorMessage, {
        className: "mt-3"
    }, error));
}
export var FormField = /*#__PURE__*/ forwardRef(RawFormField);

//# sourceMappingURL=FormField.js.map